//<div class="modal-backdrop fade in"></div>

(function ($) {
    $("document").ready(setup);

    function setup() {
        $("[data-toggle=modal]").click(modal);
        $("[data-dismiss=modal]").click(modalClose);
        var hash = location.hash.substr(1);
        if(hash) {
            modal();
        }
    }

    function modal() {
        if($("[data-toggle=modal]").length) {
            $("body").addClass("modal-open");
            $("body").after('<div class="modal-backdrop fade in"></div>');
            $(".modal.fade").addClass("in");
        }
    }

    function modalClose() {
        $("body").removeClass("modal-open");;
        $( ".modal-backdrop" ).remove();
        $(".modal.fade").removeClass("in");
    }

})(jQuery);

